// extracted by mini-css-extract-plugin
module.exports = {"component":"MemoButton_component__j9H4i","small":"MemoButton_small__2v2xw","outlined":"MemoButton_outlined__bqgKk"};